import React from 'react';

import cn from 'classnames';
import { FormProvider } from 'react-hook-form';

import { Checkbox, Themes } from '@components/inputs/Checkbox/Checkbox';
import { TextInput } from '@components/inputs/TextInput/TextInput';

import styles from './PromoCode.module.scss';

import { Button, ButtonVariant, ButtonTheme } from '@base-components/Button';
import { useLogger } from '@hooks/useLogger';
import { usePromoCode } from './usePromoCode';

const PromoCode = ({ checkText, text, couponErrorMessages, className, isFinanceContractType, inputDataAttribute = {} }) => {
  const { logger } = useLogger({ context: 'PromoCode' });
  const { coupon, methods, checkPromoCode, deleteCoupon, onPromoCodeToggle, onSubmit } = usePromoCode({
    logger,
    couponErrorMessages,
    isFinanceContractType,
  });

  return (
    <div className={cn(styles.container, className, styles.containerV2)}>
      <FormProvider {...methods}>
        <form onSubmit={onSubmit} className={styles.promoCodeForm}>
          <Checkbox
            controllerName="isPromoCode"
            labelText={text}
            theme={Themes.WhiteNoShadow}
            onClick={onPromoCodeToggle}
          >
            <div className={styles.checkboxContainer}>
              <TextInput
                controllerName="promoCode.code"
                onBlur={checkPromoCode}
                disabled={coupon || isFinanceContractType}
                dataAttribute={inputDataAttribute}
              />

              {!coupon && (
                <div className={styles.buttonContainer}>
                  <Button
                    as="button"
                    className={styles.button}
                    variant={ButtonVariant.Basic}
                    type="submit"
                    isFullWidth
                    isLoading={methods.formState.isSubmitting}
                    disabled={isFinanceContractType}
                  >
                    {checkText}
                  </Button>
                </div>
              )}

              {coupon && (
                <Button
                  as="button"
                  variant={ButtonVariant.Icon}
                  theme={ButtonTheme.RawOnLight}
                  icon="trash"
                  size="tiny"
                  className={styles.removeButton}
                  onClick={deleteCoupon}
                />
              )}
            </div>
          </Checkbox>
        </form>
      </FormProvider>
    </div>
  );
};

export default PromoCode;
